import { Layout, Spin } from 'antd'
import React from 'react'
import ResultTable from './components/ResultTable'
import { useSearchResultContext } from './index.context'
import './index.style.scss'

const SearchResultContent: React.FC = () => {
  const { loading } = useSearchResultContext()

  return (
    <Layout.Content
      className='search-result-container'
      style={{
        padding: 24,
        gap: 24,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <ResultTable />
      {loading && (
        <div
          className='search-result-loading-overlay'
          style={{
            position: 'absolute',
            inset: 0,
            background: 'rgba(255, 255, 255, 0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
          }}
        >
          <Spin size='large' />
        </div>
      )}
    </Layout.Content>
  )
}

export default SearchResultContent
